// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  message: '',
};

const actions = {
  getStock:
    (token) =>
      ({ getState, setState }) =>
        new Promise(async (resolve, reject) => {
          try {
            const options = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `bearer ${token}`,
              },
            };
            const response = await fetch(
              '/api/bread/jwt/stock_storages/static/stockByUser',
              options
            );
            const res = await response.json();
            if (response.status !== 200) {
              reject(response);
            } else {
              setState({ listParts: res.stockItems });
              resolve(getState());
            }
          } catch (e) {
            reject(e);
          }
        })
};

const StockStorage = createStore({
  initialState,
  actions,
  name: 'useStockStorage',
});

export default createHook(StockStorage);
